import { Injectable } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';

/**
 * Custom Dutch translations for Angular Material Datepicker
 * This provides Dutch text for calendar navigation buttons and labels
 */
@Injectable()
export class MatDatepickerIntlNl extends MatDatepickerIntl {
  constructor() {
    super();

    // Calendar navigation buttons
    this.prevMonthLabel = 'Vorige maand';
    this.nextMonthLabel = 'Volgende maand';
    this.prevYearLabel = 'Vorig jaar';
    this.nextYearLabel = 'Volgend jaar';
    this.prevMultiYearLabel = 'Vorige 24 jaar';
    this.nextMultiYearLabel = 'Volgende 24 jaar';

    // Period selection buttons
    this.switchToMonthViewLabel = 'Kies datum';
    this.switchToMultiYearViewLabel = 'Kies maand en jaar';

    // Range selection labels (if using date ranges)
    this.startDateLabel = 'Begindatum';
    this.endDateLabel = 'Einddatum';
  }
}
